import React from 'react';
import { Account } from '../../../../../types/account';
import AccountMultiSelect from '../../../../../components/AccountMultiSelect';

interface AccountSelectProps {
  accounts: Account[];
  selectedAccounts: string[];
  onSelectionChange: (accountIds: string[]) => void;
  placeholder?: string;
  className?: string;
}

const AccountSelect: React.FC<AccountSelectProps> = ({
  accounts,
  selectedAccounts,
  onSelectionChange,
  placeholder = 'Выберите аккаунт',
  className = '',
}) => {
  return (
    <AccountMultiSelect<Account>
      accounts={accounts}
      selectedIds={selectedAccounts}
      onSelectionChange={onSelectionChange}
      getId={(account) => account.id}
      getAvatar={(account) => account.avatar}
      getLabel={(account) => `@${account.of_user_name}`}
      getDescription={(account) => account.type}
      placeholder={placeholder}
      className={className}
    />
  );
};

export default AccountSelect;
